const UsersMain = () => import(/* webpackChunkName: "admin-module" */ './index');
const Users = () => import(/* webpackChunkName: "admin-module" */ './tabs/Users/Users');
const Roles = () => import(/* webpackChunkName: "admin-module" */ './tabs/Roles/Roles');

export default [
    {
        path: 'users',
        components: { base: UsersMain },
        children: [
            {
                path: '',
                name: 'users',
                components: { users: Users }
            },
            {
                path: 'roles',
                name: 'roles',
                components: { users: Roles }
            },
        ]
    },
];
